import { useGlobalState, useResponsive } from '@/hooks';
import { type IWrapper, ResponsiveCollection } from '@/interfaces';
import {
  SectionContainer,
  WrapperSectionContainer,
  WrapperSubText,
  WrapperTitle,
  WrapperTitleUnderline,
} from './Wrapper.styles';
import { BodyComponent } from './WrapperTemplates';

const Wrapper: React.FC<IWrapper> = ({ title, subText, backgroundColor, subTextMobile, entryList, content, image }) => {
  const { t } = useGlobalState();
  const { isMobile } = useResponsive([ResponsiveCollection.Mobile]);

  const translatedTitle = t(title ?? '');
  const translatedSubText = t(subText ?? '');
  const translatedSubTextMobile = t(subTextMobile ?? '');

  const shouldRenderWrapper = !!(entryList?.length || content);

  if (!shouldRenderWrapper) return null;

  return (
    <WrapperSectionContainer bgColor={backgroundColor}>
      <SectionContainer>
        {translatedTitle && (
          <>
            <WrapperTitle>{translatedTitle}</WrapperTitle>
            <WrapperTitleUnderline />
          </>
        )}
        {isMobile && translatedSubTextMobile && <WrapperSubText>{translatedSubTextMobile}</WrapperSubText>}
        {!isMobile && translatedSubText && <WrapperSubText>{translatedSubText}</WrapperSubText>}
        <BodyComponent image={image} content={content} entryList={entryList} />
      </SectionContainer>
    </WrapperSectionContainer>
  );
};

export default Wrapper;
